module.exports = __webpack_public_path__ + "app-store-badge-4b6e508b7824a2f3e47d.png";